import styled from 'styled-components';
import Button from './Button';
var Container = styled(Button.withComponent('div')).withConfig({
  componentId: "dacwbl-0"
})([""]);
export default Container;